import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import RewardCatalogCard from '../CatalogoPremi/RewardCatalogCard';
import InfoCILPoints from '../CILPoints/InfoCILPoints';
import { CIL_POINTS_LABEL } from '../../utils/cilPoints';

const EventRewardSetsSection = ({ rewardSets }) => {
  if (!rewardSets?.length) return null;

  return (
    <Box bg="purple.50" py={10}>
      <Container maxW="container.xl">
        <Box mb={8} maxW="3xl">
          <Heading as="h2" size="md" mb={3} color="purple.800">
            Premi in palio per questo evento
          </Heading>
          <Text color="gray.600" fontSize="md" lineHeight="tall">
            I premi collegati a questo evento e il costo in {CIL_POINTS_LABEL},
            con la quantità ancora disponibile.
          </Text>
          <Box mt={3}>
            <InfoCILPoints variant="link" tone="light" />
          </Box>
        </Box>

        {rewardSets.map((set) => {
          const rewards = set.rewards || [];
          if (!rewards.length) return null;

          return (
            <Box key={set.documentId} mb={rewardSets.length > 1 ? 10 : 0}>
              {rewardSets.length > 1 && (
                <Flex
                  justify="space-between"
                  align="flex-end"
                  gap={3}
                  mb={4}
                  flexWrap="wrap"
                >
                  <Box>
                    <Heading as="h3" size="sm" color="purple.800">
                      {set.name}
                    </Heading>
                    {set.description && (
                      <Text fontSize="sm" color="gray.600" mt={1} noOfLines={2}>
                        {set.description}
                      </Text>
                    )}
                  </Box>
                  {set.slug && (
                    <Button
                      as={Link}
                      to={`/catalogo-premi/${set.slug}`}
                      size="sm"
                      variant="outline"
                      colorScheme="purple"
                    >
                      Apri set nel catalogo
                    </Button>
                  )}
                </Flex>
              )}

              <SimpleGrid
                columns={{ base: 2, sm: 2, md: 3, lg: 4 }}
                spacing={5}
              >
                {rewards.map((reward) => (
                  <RewardCatalogCard
                    key={reward.documentId}
                    reward={reward}
                    readOnly
                  />
                ))}
              </SimpleGrid>
            </Box>
          );
        })}
      </Container>
    </Box>
  );
};

export default EventRewardSetsSection;
